import * as React from 'react';
import { ExpandableBox } from 'app/area/reports/components/expandable-box';
import { DropdownItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { FieldItem } from 'app/area/reports/types';
import { CaseReportVisualisationTranslations } from 'app/area/case-report/components/included-domains/case-listing-drawer';

interface SelectedItemProps {
  item: FieldItem;
  onUpdate: (items: FieldItem[]) => void;
  selectedItems: FieldItem[];
  translation: CaseReportVisualisationTranslations;
}

export const moveField = (fields: FieldItem[], sourceId: number, newIndex: number): FieldItem[] => {
  const newFields = [...fields];
  const [removed] = newFields.splice(sourceId, 1);
  newFields.splice(newIndex, 0, removed);
  return newFields;
};

export const SelectedCaseField = ({ onUpdate, item, selectedItems, translation }: SelectedItemProps) => {
  const handleOnRemove = () => onUpdate(selectedItems.filter(i => i.value !== item.value));
  const handleOnMoveUp = () => onUpdate(moveField(selectedItems, selectedItems.indexOf(item), selectedItems.indexOf(item) - 1));
  const handleOnMoveDown = () => onUpdate(moveField(selectedItems, selectedItems.indexOf(item), selectedItems.indexOf(item) + 1));

  const menuItems: DropdownItem[] = [
    {
      value: '1',
      description: translation.remove,
      onClick: handleOnRemove
    }
  ];

  if (selectedItems.indexOf(item) > 0) {
    menuItems.push({
      value: '2',
      description: translation.move_up,
      onClick: handleOnMoveUp
    });
  }

  if (selectedItems.indexOf(item) < selectedItems.length - 1) {
    menuItems.push({
      value: '3',
      description: translation.move_down,
      onClick: handleOnMoveDown
    });
  }

  return (
    <ExpandableBox
      key={item.value}
      title={item.description || ''}
      menuItems={menuItems}
      subTitle={item.parentAllLevelsDescription || ''}
    />
  );
};
